<template>
  <div class="container">
    <QueryFrame
      customed-text="导出Excel"
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @handleCustomed='exportExcel'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>客户:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.pharCustomerName"></lk-input>
          </div>
          <div class="queryItem">
            <label>订单号:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.saleOrderCode"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品名:</label>
            <lk-input :maxlength="100" placeholder="商品名/通用名/商品编码" class="item" clearable v-model="query.goodsName"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="gotoHandleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>

      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import service from '../../../services/lgq/services';

export default {
  name: 'saleDetailList',
  mixins: [mapState, queryMixins],
  data() {
    return {
      size: 20,
      query: {
        pharCustomerName: '',
        saleOrderCode: '',
        goodsName: '',
      },
      columns: [
        { title: '行号', key: 'lineNum', minWidth: 60 },
        { title: '订单号', key: 'saleOrderCode', minWidth: 116 },
        { title: '客户名称', key: 'pharCustomerName', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '销售数量', key: 'num', minWidth: 116 },
        { title: '退货数量', key: 'refundNum', minWidth: 116 },
        { title: '含税价格', key: 'amount', minWidth: 116 },
        { title: '不含税价格', key: 'amountWithoutTax', minWidth: 116 },
        { title: '税额', key: 'tax', minWidth: 116 },
        { title: '单价', key: 'price', minWidth: 116 },
        {
          title: '税率',
          key: 'outputTaxRate',
          minWidth: 116,
          render: (h, params) => h('span', `${params.row.outputTaxRate}%`),
        }],
      tableData: [],
    };
  },
  methods: {
    exportExcel() {
      service.exportOrderDetailList({
        pharCustomerName: this.query.pharCustomerName,
        saleOrderCode: this.query.saleOrderCode,
        goodsName: this.query.goodsName,
      }).then((res) => {
        if (res.status === 200) {
          utils.downFile(res.data, `订单明细列表${utils.formatTime(new Date().getTime(), 'YYYYMMDD')}.xlsx`);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      service.saleDetailList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count || 0;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoHandleSearch() {
      this.handleSearch();
    },
    clear() {
      this.query = {
        pharCustomerName: '',
        saleOrderCode: '',
        goodsName: '',
      };
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
  },
};
</script>

<style scoped>
</style>
